import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Category from "@/pages/Category";
import Article from "@/pages/Article";
import Contact from "@/pages/Contact";
import { Privacidad, Cookies, AvisoLegal, SobreNosotros } from "@/pages/Legal";

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/categoria/:slug" element={<Category />} />
          <Route path="/articulo/:slug" element={<Article />} />
          <Route path="/contacto" element={<Contact />} />
          <Route path="/sobre-nosotros" element={<SobreNosotros />} />
          <Route path="/politica-de-privacidad" element={<Privacidad />} />
          <Route path="/politica-de-cookies" element={<Cookies />} />
          <Route path="/aviso-legal" element={<AvisoLegal />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
